type Feedback = {
  message: string;
  type: 'success' | 'error' | null;
};

type FeedbackBannerProps = {
  feedback: Feedback;
  onClose: () => void;
};

const FeedbackBanner = ({ feedback, onClose }: FeedbackBannerProps) => {
  if (!feedback.type) return null;

  const isError = feedback.type === 'error';

  return (
    <div
      style={{
        marginTop: '1rem',
        marginBottom: '1rem',
        padding: '10px',
        borderRadius: '6px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: isError ? '#ffe5e5' : '#e6f7ec',
        color: isError ? '#b00020' : '#1b7f3b',
        border: `1px solid ${isError ? '#ffb3b3' : '#b7ebc6'}`,
      }}
    >
      <span>{feedback.message}</span>

      <button
        onClick={onClose}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        ✕
      </button>
    </div>
  );
};
export default FeedbackBanner;
